import Donations from './Donations';

export default Donations;
